import { render, staticRenderFns } from "./EditContainer.vue?vue&type=template&id=0a6ad972&scoped=true"
import script from "./EditContainer.vue?vue&type=script&lang=js"
export * from "./EditContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ad972",
  null
  
)

export default component.exports